<!-- /web/module-list -->

<template>
  <div ref="wrapper" v-wechat-title="'所有内容'" class="index-page-2">
    <div class="cate-list">
      <van-grid :border="false" :column-num="2">
        <van-grid-item v-for="(cate, index) of allowCateInfo" :key="index" @click="toModuleIndex(cate)">
          <div class="rc-container-6">
            <van-image :src="cate.iconImgV3 || 'images/index-new/class/jieqing.png'" class="img"></van-image>
            <div class="text">
              <span :style="{ color: cate.textColor }">{{
                cate.extNameV3
                }}</span>
            </div>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import {
  wx_get_goods_list_by_topic,
  mall_WxUser_get_TopicList_ByUser,
  api_get_user_cate_id_list,
} from "@/api/goods-api";
import { MallModules } from "@/api/constant";
import request from "@/util/axios";

export default {
  name: "module-list",

  data() {
    return {
      allowCateInfo: [],

      mall_modules: [],

      birthdayModule: {
        name: "birthday",
        index: "/birthday",
        addToCart: false,
        extName: "生日/Birthday",
        iconImg: "images/index-new/class/shengridangao.svg",
        indexNavFlag: 3,
        topCateId: 3,
        title: "生日",
        extNameV3: "生  日",
        iconImgV3:
          "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/rzh4qumz243dufwe38aj0xu4.png",
        textColor: "#FF7C0E",
      },
    };
  },

  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },

  created() {
    // 从后台拿所有顶级目录
    request.post("/mall/wx/wx-user-root-cate-list").then((res) => {
      // 所有顶级目录
      this.mall_modules = res.data.map((e) => {
        e.topCateId = e.cateId; // ID
        e.indexNavFlag = e.sort || e.cateId; // 排序
        e.iconImgV3 = e.icon; // 图标
        e.extNameV3 = e.name; // 显示名
        // textColor
        return e;
      }); // MallModules

      // 增加一个特殊的 专属定制 getAllowCateList 有是否展示这个的逻辑
      this.mall_modules.push(MallModules.filter((e) => 999 == e.topCateId)[0]);

      // 看客户开通了哪些目录
      this.getAllowCateList();
    });
  },

  methods: {
    getAllowCateList() {
      api_get_user_cate_id_list().then((res) => {
        this.loading = false;
        if (res.code != 0) {
          Dialog.alert({ message: res.msg || "获取用户板块失败" });
          return;
        }

        const allowCateId = res.data;
        const commonCateIdList = allowCateId.slice();
        budo_log.info(
          "#103 commonCateIdList=",
          commonCateIdList,
          "#104 userInfo=",
          this.userInfo
        );

        // 737 = 成都工务大型养路机械运用检修段委员会
        // 745 = 彭州市人民医院
        if (
          this.userInfo.customerId === 737 ||
          this.userInfo.customerId === 745
        ) {
          const index = allowCateId.findIndex((id) => id === 15);
          if (index !== -1) {
            allowCateId.splice(index, 1);
          }
        }

        // 开通了专题的 都有专属定制 这个板块
        mall_WxUser_get_TopicList_ByUser().then((topicRes) => {
          if (topicRes.code === 0 && topicRes.data) {
            allowCateId.push(999); // 专属定制
          }

          // 允许电影
          if (allowCateId.findIndex((item) => item === 2) >= 0) {
            this.allowMovieFlag = 1;
            commonCateIdList.splice(commonCateIdList.indexOf(2), 1);
          }

          if (allowCateId.findIndex((item) => item === 7) >= 0) {
            commonCateIdList.splice(commonCateIdList.indexOf(7), 1);
          }

          if (allowCateId.findIndex((item) => item === 8) >= 0) {
            commonCateIdList.splice(commonCateIdList.indexOf(8), 1);
          }

          const modules = this.mall_modules.slice();
          if (
            allowCateId.findIndex((item) => item === 3) >= 0 && // 允许列表有生日蛋糕 但分类列表没有
            this.mall_modules.findIndex((e) => e.cateId == 3) < 0
          ) {
            // 如果分类列表返回了蛋糕 就不再加一个了
            modules.push(this.birthdayModule);
          }

          budo_log.info(
            "#137 mall_WxUser_get_TopicList_ByUser",
            commonCateIdList
          );

          this.allowCateInfo = modules
            .filter(
              (f) =>
                allowCateId.findIndex((item) => item === f.topCateId) >= 0 &&
                f.indexNavFlag > 0
            )
            .sort((a, b) => a.indexNavFlag - b.indexNavFlag);

          this.commonCateList = modules
            .filter(
              (f) =>
                commonCateIdList.findIndex((item) => item === f.topCateId) >=
                0 && f.indexNavFlag > 0
            )
            .sort((a, b) => a.indexNavFlag - b.indexNavFlag);

          budo_log.info(
            "#136 allowCateInfo=",
            this.allowCateInfo,
            "commonCateList=",
            this.commonCateList,
            "modules=",
            modules
          );

          // 热卖
          wx_get_goods_list_by_topic(7, "", 1, 4).then((res) => {
            this.goodsListByTime = res.data.records;
          });
        });
      });
    },

    toModuleIndex(cate) {
      budo_log.info("#142 toModuleIndex", cate);

      if (cate.targetUrl) {
        location.href = cate.targetUrl;
        return;
      }

      var id = parseInt(cate.topCateId);
      if (id === 2) {
        location.href = location.origin + "/movie/index";
        return;
      }

      if (id === 999) {
        this.$router.push("/topic-list");
        return;
      }

      let mid = id;

      let module = this.mall_modules.find((mall) => mall.topCateId === mid);
      if (id === 3) {
        module = this.birthdayModule;
      }

      if (module) {
        this.$store.commit("SET_MALL_MODULE", module);
        sessionStorage.setItem("rc.module-info", JSON.stringify(module));

        this.$store.commit("CLEAR_CART");
        this.$EventBus.$emit("routeInfo", JSON.stringify(module || {}));

        budo_log.info("#83 module_name", module);
      }

      let url = "/common-index?cateId=" + id;
      switch (id) {
        case 3:
          url = "/birthday";
          break;
        case 1:
          url = "/index";
          break;
        case 7:
          url = "/travel-index";
          break;
        case 8:
          url = "/health-index";
          break;
        case 20: // 在线点餐跳转
          url = "/hw-h5"; // 海威H5点餐
          break;
        default:
          break;
      }

      this.$router.push(url);
    },
  },
};
</script>

<style scoped lang="scss">
.index-page-2 {
  background-color: #fff;
  min-height: 100vh;
  padding-bottom: 200px;

  ::v-deep {
    .van-grid-item__content {
      padding: unset;
    }
  }

  .cate-list {
    padding: 4px 10px;

    .rc-container-6 .img {
      position: relative;
      z-index: 0;
      min-width: 177px;
      min-height: 88px;
    }

    .rc-container-6 .text {
      position: absolute;
      left: 32px;
      top: 32px;
      font-size: 18px;
      font-weight: bold;
      z-index: 1;
    }
  }
}
</style>
